import styled from 'styled-components';

import mediaQueries from 'constants/mediaQueries';
import { H6, ParagraphRegular } from 'components/shared/typography';
import { colorGrey400 } from 'constants/colors';

const maxWidthChooser = ({ size }: { size?: string }) => {
  switch (size) {
    case 'xlg':
      return '100%';
    case 'lg':
      return '50%';
    case 'md':
    default:
      return '350px';
  }
};

export const Wrapper = styled.div<{ backgroundColor?: string }>`
  background-color: ${props => props.backgroundColor || colorGrey400};
`;

export const FlexibleLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 54px 0;

  ${mediaQueries.mobileOnly} {
    flex-direction: column;
    padding: 40px 0;
  }
`;

export const ComponentWrapper = styled.div`
  display: flex;
  flex: 1;
  margin: 0px 8px;
  max-width: ${maxWidthChooser};

  ${mediaQueries.mobileOnly} {
    max-width: 100%;
    margin: 0px;

    :not(:last-child) {
      margin-bottom: 24px;
    }
  }
`;

export const ComponentIcon = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 16px;
`;

export const HeadingWrapper = styled.div`
  margin-bottom: 4px;
`;

export const Heading = H6;
export const Paragraph = ParagraphRegular;
